module.exports = __webpack_public_path__ + "fonts/roboto-latin-700-normal.227c931.woff2";